import { render, staticRenderFns } from "./courseDetail.vue?vue&type=template&id=1f697eab&scoped=true"
import script from "./courseDetail.vue?vue&type=script&lang=js"
export * from "./courseDetail.vue?vue&type=script&lang=js"
import style0 from "./courseDetail.vue?vue&type=style&index=0&id=1f697eab&prod&lang=css"
import style1 from "./courseDetail.vue?vue&type=style&index=1&id=1f697eab&prod&scoped=true&lang=scss"
import style2 from "./courseDetail.vue?vue&type=style&index=2&id=1f697eab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f697eab",
  null
  
)

export default component.exports